import React, { useEffect, useState } from 'react';
// import Card from "../../components/elements/Card";
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import {
  Avatar,
  Flex,
  Image,
  Indicator,
  Popover,
  Tabs,
  Text,
  ThemeIcon,
  Title,
  Card,
  Badge,
  Button,
  Group,
  Grid,
  Container,
  Center,
  TextInput
} from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import { resetWidget, searchUser } from '../../services/resetWidget';

const ResetWidget = (props) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });
  const [isProgress, setIsProgress] = useState(false);

  const handleMutate = () => {
    let payload;
    if (tempUser.length === 0) {
      payload = {
        userID: []
      };
    } else {
      payload = {
        userID: tempUser.map((item) => item.binusianId)
      };
    }

    _hanldeResetWidget.mutate(payload);
  };

  const _hanldeResetWidget = useMutation({
    mutationFn: resetWidget,
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Success Reset Widget',
        message: 'Widget has been reset successfully.'
      });
      setTempUser([]);
      setListUserSearched([]);
      setSearch('');
      setModalDialog({
        show: false,
        data: null
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const [search, setSearch] = useState('');
  const [listUserSearched, setListUserSearched] = useState([]);
  const [tempUser, setTempUser] = useState([]);

  const handleSearch = () => {
    if (isProgress) return;
    setIsProgress(true);
    if (!search) {
      showNotification({
        type: 'error',
        message: 'Please input the search field.'
      });
      return;
    }

    setListUserSearched([]);
    setTempUser([]);

    const payload = {
      keyword: search,
      page: 1,
      take: 20
    };
    handleMutateSearchUser.mutate(payload);
  };

  const handleMutateSearchUser = useMutation({
    mutationFn: searchUser,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        setIsProgress(false);
        setListUserSearched(response?.data?.data);
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your interest',
          message:
            response?.data?.errorMessage ||
            'Failed when save interest. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleChooseUser = (user) => {
    setTempUser([...tempUser, user]);
    setListUserSearched([]);
  };

  const handleRemoveUser = (user) => {
    const temp = tempUser.filter((item) => item.email !== user.email);
    setTempUser(temp);
  };

  useEffect(() => {
    const bounce = setTimeout(() => {
      search !== '' && handleSearch();
    }, 1000);

    return () => {
      clearTimeout(bounce);
    };
  }, [search]);

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Reset Widget"
        itemList={[
          {
            title: 'BCL&D Back Office',
            href: '#',
            icon: <Unicons.UilFileCopyAlt />
          },
          {
            title: 'Reset Widget',
            href: 'management/reset-widget'
          }
        ]}
      />

      <Container size={'xs'}>
        <Tabs defaultValue="all">
          <Tabs.List>
            <Tabs.Tab value="all">All User</Tabs.Tab>
            <Tabs.Tab value="spu">Specific User</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="all">
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <Group justify="space-between" mt="md" mb="xs">
                <Title order={3}>Reset Widget Personal Dashboard</Title>
                <Text fw={500}>
                  If you want to reset the widget for all users, please click
                  the button below.
                </Text>
              </Group>
              <Button
                color="#7B2183"
                fullWidth
                mt="md"
                radius="md"
                onClick={() => {
                  setTempUser([]);
                  setModalDialog({
                    show: true,
                    data: null
                  });
                }}
              >
                Reset Widget
              </Button>
            </Card>
          </Tabs.Panel>

          <Tabs.Panel value="spu">
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <Group justify="space-between" mt="md" mb="xs">
                <Title order={3}>Reset Widget Personal Dashboard</Title>
                <Text fw={500}>
                  If you want to reset the widget for some users, please input
                  the user name below, and also choose the user, then you can
                  click the button below.
                </Text>
              </Group>
              <div className="input-wrapper">
                <input
                  className="input"
                  placeholder={'Search for user'}
                  readOnly={isProgress || tempUser.length > 0}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px'
                  }}
                />
              </div>
              {listUserSearched.length > 0 && (
                <>
                  <Text mt="md" mb="xs" fw={'bold'}>
                    {' '}
                    List User{' '}
                  </Text>
                  <div style={{ maxHeight: '150px', overflow: 'auto' }}>
                    {/* map the list user */}
                    {listUserSearched.map((user, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px',
                            borderBottom: '1px solid #ccc'
                          }}
                        >
                          <div>
                            <Text>{user?.fullName}</Text>
                            <Text size="xs">{user?.email}</Text>
                          </div>
                          <Button
                            color="#7B2183"
                            radius="md"
                            onClick={() => {
                              setSearch('');
                              handleChooseUser(user);
                            }}
                          >
                            Choose
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {tempUser.length > 0 && (
                <>
                  <Text mt="md" mb="xs" fw={'bold'}>
                    {' '}
                    List User Terpilih{' '}
                  </Text>
                  <div>
                    {/* map the list user */}
                    {tempUser.map((user, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px',
                            borderBottom: '1px solid #ccc'
                          }}
                        >
                          <div>
                            <Text>{user?.fullName}</Text>
                            <Text size="xs">{user?.email}</Text>
                          </div>
                          <Button
                            color="red"
                            radius="md"
                            onClick={() => {
                              handleRemoveUser(user);
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              <Button
                color={
                  isProgress
                    ? 'lightgray'
                    : tempUser.length === 0
                    ? 'lightgray'
                    : '#7B2183'
                }
                fullWidth
                mt="md"
                radius="md"
                onClick={() => {
                  tempUser.length === 0
                    ? handleSearch()
                    : setModalDialog({
                        show: true,
                        data: null
                      });
                }}
              >
                {tempUser.length > 0
                  ? 'Reset Widget'
                  : isProgress
                  ? 'Searching user...'
                  : 'Please Choose User'}
              </Button>
            </Card>
          </Tabs.Panel>
        </Tabs>

        <ModalConfirmation
          isVisible={modalDialog.show}
          title="Reset Widget"
          type="edit"
          onCancel={() => {
            setModalDialog({
              show: false,
              data: null
            });
          }}
          onConfirm={() => {
            handleMutate();
          }}
        />
      </Container>
    </AdminLayout>
  );
};

function checkIsEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default ResetWidget;
